import React from 'react';

import cx from 'classnames';

import { Link } from '@commons/link/Link';

import Image from '@commons/image/Image';

import * as styles from './case-study-card.module.scss';

export const CaseStudyCard = ({ link, description, categories, services, thumbnail, className }) => {
  return (
    <Link className={cx(styles.card, className)} href={link}>
      <div>
        <Image image={thumbnail} alt={`Thumbnail of a case study about ${description}`} />
      </div>
      <div className={styles.content}>
        <div className={styles.title}>{description}</div>
        <hr />
        <div className={styles.info}>
          <div className={styles.categories}>
            <h5>Categories</h5>
            {categories.map((category, index) => (
              <span className={styles.category} key={category}>
                {index !== 0 && <span> | </span>}
                {category}
              </span>
            ))}
          </div>
          <div>
            <h5>Services</h5>
            {services.map((service, index) => (
              <span className={styles.services} key={service}>
                {index !== 0 && <span> &nbsp;|&nbsp;</span>}
                {service}
              </span>
            ))}
          </div>
        </div>
      </div>
    </Link>
  );
};
